import layout from './EmbeddedMediumImageLabel.html?raw';
import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import EmbeddedMediumImageViewModelT from '@/ViewModels/Controls/EmbeddedMediumImageLabelViewModel';

export default class EmbeddedMediumImageLabel extends Control {
    private jQueryControl: JQuery;

    public constructor(private viewModel: EmbeddedMediumImageViewModelT, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated((widget) => {
            this.applyBindings(this.jQueryControl, {
                controlName: 'embeddedmediumimagelabel',
                tooltip: this.context.tooltip
            });

            this.applyBindings(this.jQueryControl.children('div'), {
                style: {
                    width: this.viewModel.thumbWidth + 'px',
                    height: this.viewModel.thumbHeight + 'px',
                }
            });
        });
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<span></span>');
        this.applyTemplate(layout, this.jQueryControl, () => {
            this.widget(null);
        });

        return this.jQueryControl;
    }
}

ComponentManager.setControl('EmbeddedMediumImageLabel', EmbeddedMediumImageLabel, 'RADPresentation.HTMLClient.DefaultViewExtensions');